import isServer from '../env/is-server';

/**
 * 获取cookie
 * todo 修复多个`=`带来的bug
 * @param cookieName
 */
export function getCookie(cookieName: string): string | null {
  let arr;
  const reg = new RegExp(`(^| )${cookieName}=([^;]*)(;|$)`);
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  }
  return null;
}

/**
 * 设置 cookie
 * @param {*} cname
 * @param {*} cvalue
 * @param {*} exdays 单位: 天
 * @param {*} pathValue 写入路径
 */
export const setCookie = (cname: any, cvalue: any, exdays: any = 1, pathValue: any = '/') => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  if (!isServer) {
    const expires = `expires=${d.toUTCString()}`;

    let cookiePath = '';
    if (pathValue) {
      cookiePath = `; path=${pathValue}`;
    }
    document.cookie = `${cname}=${cvalue}; ${expires}${cookiePath}`;
  }
};
